"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initSocialSharing = exports.share = void 0;
const platforms_1 = require("./platforms");
function share(options) {
    const { url, platform } = options;
    const shareUrl = platforms_1.socialLinks[platform](url);
    if (shareUrl) {
        window.open(shareUrl, '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600');
    }
    else {
        console.warn('Unsupported platform:', platform);
    }
}
exports.share = share;
function initSocialSharing() {
    const shareButtons = document.querySelectorAll('.social-share');
    shareButtons.forEach(button => {
        button.addEventListener('click', (event) => {
            event.preventDefault();
            const platform = button.getAttribute('data-platform');
            const url = button.getAttribute('data-url') || window.location.href;
            if (platform && url) {
                share({ url, platform });
            }
        });
    });
}
exports.initSocialSharing = initSocialSharing;
